module.exports = __webpack_public_path__ + "static/user3-b102c0e41d794cbdeec96b0372532f10.png";